<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Komposisi obat</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Obat / Komposisi obat</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          icon="pi pi-plus"
          label="Komposisi obat"
          class="mr-2"
          @click="onAddKomposisiObat()"
        />
        <Button
          :loading="isLoadingExport"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined"
          @click="onExport()"
        />
      </div>
      <fx-table
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
      >
        <template #columns>
          <Column
            field="golongan_id"
            header="Golongan"
            style="min-width: 250px"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ data.golongan }}
            </template>
          </Column>
          <Column
            field="kode"
            header="Kode"
            style="min-width: 110px"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ data.kode }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                placeholder="Kode"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            :sortable="true"
            field="komposisi"
            header="Komposisi"
            style="min-width: 700px"
          >
            <template #body="{ data }">
              {{ data.komposisi }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Cari komposisi obat"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-outlined p-button-danger p-button-text"
                @click="onConfirmDeletion(data)"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      :header="
        form && form.id > 0 ? 'Edit Komposisi obat' : 'Tambah Komposisi obat'
      "
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <form-komposisi-obat
        :loading="isLoadingSave"
        :item="form"
        :golongan-obat="golonganObat"
        @save="onSaveKomposisiObat"
      />
    </Dialog>
    <Dialog
      header="Hapus Komposisi obat"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Komposisi obat <strong>{{ form.komposisi }}</strong> akan dihapus.
          Proses ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteKomposisiObat"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import errorHandler from '@/helpers/error-handler'
import GolonganObatService from '@/services/GolonganObatService'
import FormKomposisiObat from '@/components/master/FormKomposisiObat'
import FxTable from '@/components/FxTable'
import Hotkey from '@/components/Hotkey'
import KomposisiObatService from '@/services/KomposisiObatService'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'KomposisiObat',
  components: {
    FormKomposisiObat,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      komposisiObatService: null,
      dialog: false,
      dialogHapus: false,
      isLoading: false,
      isLoadingSave: false,
      isLoadingExport: false,
      items: [],
      form: {},
      golonganObat: [],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'kode',
        sortOrder: -1,
        filters: null,
      },
      filters: {
        kode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        komposisi: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    }
  },
  created() {
    this.komposisiObatService = new KomposisiObatService()
  },
  mounted() {
    this.loadData()
    const golonganObatService = new GolonganObatService()
    golonganObatService
      .get()
      .then((res) => {
        this.golonganObat = res.data.data
      })
      .catch((err) => {
        errorHandler(err, 'Data golongan obat', this)
      })
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.komposisiObatService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Komposisi obat', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onEditData(data) {
      this.form = Object.assign({}, data)
      this.dialog = true
    },
    onAddKomposisiObat() {
      this.form = {
        id: 0,
      }
      this.dialog = true
    },
    onSaveKomposisiObat(data) {
      this.isLoadingSave = true
      if (data && data.id === 0) {
        // add new
        this.komposisiObatService
          .add(data)
          .then((res) => {
            if (res.data.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Data Komposisi obat',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.loadData()
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data Komposisi obat', this)
          })
          .finally(() => (this.isLoadingSave = false))
      } else if (data && data.id >= 0) {
        // edit
        this.komposisiObatService
          .update(data)
          .then((res) => {
            if (res.data.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Data Komposisi obat',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.loadData()
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data Komposisi obat', this)
          })
          .finally(() => (this.isLoadingSave = false))
      }
    },
    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeleteKomposisiObat() {
      this.komposisiObatService
        .delete(this.form.id)
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Komposisi obat',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
            this.loadData()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Komposisi obat', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddKomposisiObat()
      }
    },
    onExport() {
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters
      this.isLoadingExport = true
      this.komposisiObatService
        .export(sortField, sortOrder, filters)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'data-komposisi-obat.xls')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Export Data Komposisi Obat', this)
        })
        .finally(() => (this.isLoadingExport = false))
    },
  },
}
</script>
